export default `
  :root {

    /* Colors */

    --beek-blue: #36D7DC;
    --medium-beek-blue: #34DFE5;
    --dark-beek-blue: #00638F;
    --sky-blue: #6FE2E6;
    --snow-blue: rgba(237, 241, 243, 0.48);
    --snow-blue-solid: rgba(237, 241, 243);
    --cold-blue: #C5F3F5;
    --medium-blue: #009BE0;
    --bright-blue: #00B0FF;
    --mint-green: #8CEBCB;
    --spring-green: #36DCA5;
    --white: #FFFFFF;
    --gray-100: rgba(38, 37, 37);
    --gray-70: rgba(38, 37, 37, 0.7);
    --gray-50: rgba(38, 37, 37, 0.5);
    --gray-35: rgba(38, 37, 37, 0.35);
    --gray-15: rgba(38, 37, 37, 0.15);
    --light-gray: #DADADA;
    --red: #d24347;
    --black: #000000;
    --bright-yellow: #F0EB74;
    --red-alert: rgba(248,5,35,0.7);
    --medium-red: #D6494C;
    --medium-green: #609D3D;
    --dark-green: #48752E;
    --bright-green: #7AC74D;

    /* Fonts */

    --primary-font: 'Nunito Sans';

  }
`;
